module.exports = __webpack_public_path__ + "img/part6-icon5.35849e7d.png";